import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sistema_mantenimiento',
  templateUrl: './sistema_mantenimiento.component.html',
  styleUrls: ['./sistema_mantenimiento.component.css']
})
export class Sistema_mantenimientoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
